import React from "react"
import styled from "@emotion/styled"
import Global from "./global-style"
import Head from "./head"
import { PageTransition } from "../molecules/pageTranstion"
import { AppContextProvider } from '../../context'
import { AuthProvider } from "../../services/auth"

const GlobalContainer = styled.div`
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
`
const GlobalLayout = ({bgColor, children}) => 
<>
    <Head />
    <Global bgColor={bgColor} />
    <GlobalContainer>
        <AppContextProvider>
        <PageTransition>
            <AuthProvider>
            {children}
            </AuthProvider>
        </PageTransition>
        </AppContextProvider>
    </GlobalContainer>
</>


export default GlobalLayout